<template>
    <div>
        <h1>New Event</h1>
        <v-form>
            <v-text-field placeholder="イベント名" v-model="eventName"></v-text-field>
            <v-btn @click="register">登録</v-btn>
        </v-form>
    </div>
</template>
<script>
    import firebase from 'firebase'
    export default {
        data() {
            return {
                eventName: ""
            }
        },
        methods: {
            register: function() {
                const user = firebase.auth().currentUser
                const db = firebase.firestore()
                const userRef = db.collection("users").doc(user.uid)
                const eventRef = userRef.collection("events").doc()
                eventRef.set({
                    name: this.eventName,
                    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
                }).then(() => {
                    this.$router.push({name: "event", params: {id: eventRef.id}})
                }).catch((err) => {
                    console.error(err.message)
                })
            }
        }
    }

</script>